import { useState } from 'react';
import { MdClose } from 'react-icons/md';
import {
  buildWhatsAppUrl,
  CONTACT_WIDGET_AVATAR_SRC,
  CONTACT_WIDGET_NAME,
  CONTACT_WIDGET_SUPPORT_EMAIL,
  CONTACT_WIDGET_WHATSAPP_NUMBER,
  CONTACT_WIDGET_WHATSAPP_PREFILL_TEXT,
} from './contactWidgetConfig';

const whatsappUrl = buildWhatsAppUrl(CONTACT_WIDGET_WHATSAPP_NUMBER, CONTACT_WIDGET_WHATSAPP_PREFILL_TEXT);
const emailHref = `mailto:${CONTACT_WIDGET_SUPPORT_EMAIL}`;

const ContactWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="pointer-events-none fixed bottom-5 right-5 z-[60] flex max-w-[calc(100vw-2.5rem)] flex-col items-end gap-3 sm:bottom-6 sm:right-6">
      {isOpen && (
        <section className="pointer-events-auto w-[min(20rem,calc(100vw-2.5rem))] rounded-2xl border border-gray-200 bg-white p-4 shadow-[0_18px_50px_-24px_rgba(15,23,42,0.45)]">
          <div className="flex items-center gap-3">
            <div className="relative shrink-0">
              <img
                src={CONTACT_WIDGET_AVATAR_SRC}
                alt={`${CONTACT_WIDGET_NAME} avatar`}
                className="h-11 w-11 rounded-full border border-gray-200 object-cover"
              />
              <span
                className="absolute bottom-0 right-0 h-3 w-3 rounded-full border-2 border-white bg-emerald-500"
                aria-hidden="true"
              />
            </div>

            <div className="min-w-0 flex-1">
              <h2 className="text-md font-semibold text-gray-900">Chat to {CONTACT_WIDGET_NAME} now</h2>
            </div>

            <button
              type="button"
              onClick={() => setIsOpen(false)}
              className="inline-flex h-8 w-8 items-center justify-center rounded-full text-gray-400 transition hover:bg-gray-100 hover:text-gray-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-proposio-purple/45 focus-visible:ring-offset-2"
              aria-label="Minimise contact widget"
            >
              <MdClose className="h-4 w-4" />
            </button>
          </div>

          <div className="mt-4 space-y-3">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex w-full items-center justify-center rounded-xl bg-emerald-500 px-4 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-emerald-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/45 focus-visible:ring-offset-2"
            >
              Chat on WhatsApp
            </a>

            <p className="text-sm text-gray-600">
              Or email us at{' '}
              <a
                href={emailHref}
                className="font-medium text-gray-900 underline decoration-gray-300 underline-offset-2 transition hover:decoration-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-proposio-purple/45 focus-visible:ring-offset-2"
              >
                {CONTACT_WIDGET_SUPPORT_EMAIL}
              </a>
            </p>
          </div>
        </section>
      )}

      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="pointer-events-auto inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white/95 px-3 py-2 text-sm font-medium text-gray-700 shadow-[0_12px_30px_-20px_rgba(15,23,42,0.55)] backdrop-blur transition hover:border-gray-300 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-proposio-purple/45 focus-visible:ring-offset-2"
        aria-label="Open contact widget"
      >
        <span className="relative shrink-0">
          <img
            src={CONTACT_WIDGET_AVATAR_SRC}
            alt={`${CONTACT_WIDGET_NAME} avatar`}
            className="h-7 w-7 rounded-full border border-gray-200 object-cover"
          />
          <span
            className="absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full border border-white bg-emerald-500"
            aria-hidden="true"
          />
        </span>
        <span>Speak to us</span>
      </button>
    </div>
  );
};

export default ContactWidget;
